
export class ApplicationIdDto {
  applicationId: number;
}

export class GetUserAppListResponse {
  appList: UserAppResponse[];
}

export class UserAppResponse {
  userId: number;
  applicationId: number;
  applicationName?: string; // Display name of the app (backend may omit until rolled out)
  userName: string;
  email: string;
  userType: AppUserType;
}

export enum AppUserType {
  Reader = 'Reader',
  Writer = 'Writer',
  Admin = 'Admin',
  Owner = 'Owner',
}

export interface CreateAppUserRequest {
  applicationId: number;
  userName: string;
  email: string;
  userType: AppUserType;
}

export interface DeleteAppUserByIdRequest {
  userId: number;
}

export interface DeleteAppUserByEmailRequest {
  applicationId: number;
  email: string;
}

export interface UpdateAppUserRoleRequest {
  applicationId: number;
  email: string;
  newRole: AppUserType;
}
